// This page serves as a landing URL for Google Ads "Begin checkout" tracking.
// It redirects to the main order page where the actual checkout flow lives.
// Google Ads just needs this URL to exist and be reachable.

import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ShoppingCart } from 'lucide-react'

export default function OrderCheckout() {
  return (
    <div>
      <section className="bg-charcoal relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-20">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-6 h-0.5 bg-terracotta" />
            <span className="font-body text-[11px] font-semibold tracking-[0.25em] uppercase text-terracotta">Checkout</span>
          </div>
          <h1 className="font-display text-cream tracking-[0.04em] leading-[0.95]" style={{ fontSize: 'clamp(36px, 5vw, 72px)' }}>
            Checkout
          </h1>
          <p className="text-sm text-muted mt-3 max-w-xl">Complete your order details and choose a payment method.</p>
        </div>
      </section>
      <div className="h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />
      <section className="bg-umber">
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-20 text-center">
          <ShoppingCart size={48} className="text-terracotta mx-auto mb-6" />
          <h2 className="font-display text-cream text-2xl tracking-wide mb-4">Ready to order?</h2>
          <p className="text-sm text-ink-mid mb-8 leading-relaxed">
            Browse our menu, add items to your basket, and proceed to checkout.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-terracotta text-white font-body text-[13px] font-bold tracking-[0.1em] uppercase px-9 py-4 hover:bg-terracotta-glow hover:-translate-y-0.5 transition-all"
          >
            Start Ordering
          </Link>
        </div>
      </section>
    </div>
  )
}
